export default "__VITE_ASSET__5f69bfbb__"